import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { formatMoney } from "@/lib/currency";
import { Check } from "lucide-react";

export default function OrderConfirmation() {
  const { orderId } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order || null);

  useEffect(() => {
    if (!order) api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId, order]);

  return (
    <div className="bg-ivory min-h-screen flex flex-col" data-testid="order-confirmation">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-8 py-24">
        <div className="max-w-xl w-full text-center">
          <div className="w-16 h-16 mx-auto rounded-full border-2 border-brass flex items-center justify-center mb-8">
            <Check className="w-7 h-7 text-brass" />
          </div>
          <span className="editorial-label" data-testid="order-number">order · {order?.order_number || "—"}</span>
          <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-4">thank you.</h1>
          <p className="text-espresso leading-relaxed mb-10">
            your piece is reserved and on its way to the wrapping bench. a confirmation just landed in your inbox; tracking will follow when it leaves the atelier.
          </p>

          {order && (
            <div className="bg-linen border border-taupe/50 p-8 text-left" data-testid="confirmation-card">
              <p className="editorial-label">{order.item_snapshot?.title?.toLowerCase()}</p>
              <p className="font-serif text-3xl text-charcoal mt-2">{formatMoney(order.subtotal, order.currency)}</p>
              <div className="mt-6 space-y-2 text-sm text-charcoal">
                <div className="flex justify-between"><span>shipping</span><span>{formatMoney(order.shipping_fee, order.currency)}</span></div>
                <div className="flex justify-between"><span>{order.tax_label || "tax"} · {order.vat_rate}%</span><span>{formatMoney(order.vat_amount, order.currency)}</span></div>
                <div className="border-t border-taupe/40 pt-3 flex justify-between font-medium text-brass"><span>total</span><span className="tabular-nums">{formatMoney(order.total, order.currency)}</span></div>
              </div>
              <p className="text-xs text-espresso mt-6 leading-relaxed">ship to · {order.address_line}, {order.city} {order.postal_code} {order.state || ""} {order.country}</p>
            </div>
          )}

          <Link to="/shop" data-testid="continue-shopping" className="inline-block mt-10 bg-brass hover:bg-espresso text-ivory px-10 py-4 text-sm tracking-[0.25em] uppercase transition-colors">continue browsing</Link>
          <p className="editorial-label mt-8">curated with intention.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
